import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Image from 'next/image';
import { GeneralBodyProps } from '@components/GeneralBody';
import { AnchorProps } from '@repo/ui/src/components/Anchor';

const ErrorBody = ({ body }: GeneralBodyProps) => {
  const errorBody = body[0];

  return (
    <div className="px-8 py-8 sm:px-12 sm:py-12 m-auto max-w-smallBody">
      <h1 className="tra-text-web-heading-4 text-center mb-10">
        {errorBody?.title || 'Page Not Found'}
      </h1>
      <div className="flex flex-col sm:flex-row justify-center">
        <div className="flex flex-1 justify-center mb-2">
          {errorBody?.image && (
            <Image
              src={buildImageSrc(errorBody?.image, 450, 1, 1)}
              alt="404 Image"
              width={450}
              height={450}
              style={{ width: '100%', height: 'auto' }}
            />
          )}
        </div>
        <div className="flex-1 sm:pl-5">
          {errorBody?.description && <p className="mb-4">{errorBody?.description}</p>}
          <ul className="list-none">
            {errorBody?.links &&
              errorBody?.links.map((link: AnchorProps, i: number) => {
                const linkObj = buildLinkObj(link);
                return (
                  <li key={`404Link_${i}`}>
                    <a rel={getRel(linkObj)} href={linkObj.href} className="underline">
                      {linkObj.text}
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ErrorBody;
